import React from "react";
import { Box, Link } from "@mui/material";
import LeagueSpartanText from "../typography/LeagueSpartanText";
import { trackEvent } from "../../utils/analytics";

export default function Footer() {
    return (
        <Box
            component="footer"
            sx={{
                width: "100%",
                mt: "auto",
            }}
        >
            {/* Copyright bar */}
            <Box
                sx={{
                    width: "100%",
                    backgroundColor: "footer.default",
                    py: 1,
                    px: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexDirection: { xs: "column", sm: "row" },
                }}
            >
                {/* Left Side */}
                <LeagueSpartanText
                    variant="body2"
                    sx={{
                        color: "common.white",
                        textAlign: "left",
                        fontWeight: "light",
                        fontSize: { xs: 12, sm: 10, md: 12, lg: 14, xl: 14 },
                    }}
                >
                    © 2025 San Miguel Family Foods, All Rights Reserved
                </LeagueSpartanText>

                {/* Right Side */}
                <LeagueSpartanText
                    variant="body2"
                    sx={{
                        color: "common.white",
                        textAlign: "right",
                        fontWeight: "light",
                        fontSize: { xs: 12, sm: 10, md: 12, lg: 14, xl: 14 },
                    }}
                >
                    Powered by{" "}
                    <Link
                        href="https://www.instagram.com/dtech.mx" // <-- replace with exact URL
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => trackEvent("dtech_click", { platform: "instagram" })}
                        underline="none"
                        sx={{
                            color: "common.white",
                            fontWeight: 500,
                            cursor: "pointer",
                        }}
                    >
                        <b>Dtech</b>
                    </Link>
                </LeagueSpartanText>
            </Box>
        </Box>
    );
}